module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_20 (27).302794b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_20 (27).mp4
// module id = 802
// module chunks = 1